import { motion } from "framer-motion";
import Lottie from "lottie-react";
import IaSearch from "../../assets/lotties/ia-search.json";

function LoadingIa({ height }: { height?: string }) {
    return (
        <motion.div
            layout
            style={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
            }}
        >
            <Lottie
                animationData={IaSearch}
                loop
                autoplay
                style={{
                    width: "100%",
                    maxWidth: "70%",
                    height: height
                }}
            />
        </motion.div>
    );
}

export default LoadingIa;
